import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=e163b504&scoped=true"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=e163b504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e163b504",
  null
  
)

export default component.exports